<script>
    import Accordion from "./Accordion.svelte";

    export let questions = [];
    let filteredQuestions = [];
    let filteredQuestionsFirstHalf = [];
    let filteredQuestionsSecondHalf = [];
    let halfPoint = 0;
    let searchTerm = "";

    $: if (searchTerm != "") {
        filteredQuestions = [];
        questions.forEach((question) => {
            if (
                question.question
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()) ||
                question.answer.toLowerCase().includes(searchTerm.toLowerCase())
            ) {
                filteredQuestions.push(question);
            }
        });
        halfPoint = Math.floor(filteredQuestions.length / 2);

        filteredQuestionsFirstHalf = filteredQuestions.slice(0, halfPoint);
        filteredQuestionsSecondHalf = filteredQuestions.splice(
            halfPoint,
            filteredQuestions.length,
        );
    } else {
        filteredQuestions = [...questions];
        halfPoint = Math.floor(filteredQuestions.length / 2);

        filteredQuestionsFirstHalf = filteredQuestions.slice(0, halfPoint);
        filteredQuestionsSecondHalf = filteredQuestions.splice(
            halfPoint,
            filteredQuestions.length,
        );
    }
</script>

<section class="faq-archive">
    <div class="categories-container">
        <input
            class="faq-filter-search"
            type="text"
            bind:value={searchTerm}
            placeholder="Search"
        />
    </div>
    <div class="flex-questions-container">
        {#if filteredQuestionsFirstHalf.length > 0}
            <div class="questions-container">
                {#each filteredQuestionsFirstHalf as question}
                    <Accordion
                        question={question.question}
                        answer={question.answer}
                    />
                {/each}
            </div>
        {/if}

        {#if filteredQuestionsSecondHalf.length > 0}
            <div class="questions-container">
                {#each filteredQuestionsSecondHalf as question}
                    <Accordion
                        question={question.question}
                        answer={question.answer}
                    />
                {/each}
            </div>
        {/if}
    </div>
</section>
